<template>
  <Modal
    v-bind="$attrs"
    buttons-class=""
    hide-close-button
    @close="emit('cancel')"
  >
    <div class="tw:mb-5 tw:flex">
      <h3 class="tw:grow tw:text-base">
        {{ getLocaleText("modals.ai_feedback_modal.tell_us_more") }}
      </h3>
      <div class="tw:w-fit tw:flex-1 tw:text-right">
        <BaseIcon
          class="tw:cursor-pointer!"
          icon="close"
          @click="cancel"
        />
      </div>
    </div>

    <div
      v-for="(reason, rIndex) in reasons"
      :key="rIndex"
    >
      <div class="tw:mb-5">
        <Radio
          v-model="selectedReason"
          class="tw:text-sm!"
          :label="reason.label"
          :name="reason.label"
          new-design
          :value="reason.value"
        />
      </div>
    </div>
    <BaseButton
      class="tw:w-full tw:rounded-xl! tw:bg-[#094791]! tw:py-2 tw:text-sm tw:text-white!"
      :label="getLocaleText('modals.ai_feedback_modal.submit')"
      @click="submitFeedback"
    />
  </Modal>
</template>

<script setup lang="ts">
import { ref } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import { BaseButton, BaseIcon } from "shared/components/base";
import Radio from "shared/components/core/forms/Radio.vue";
import Modal from "shared/components/core/modals/Modal.vue";

const selectedReason = ref("");

const reasons = [
  {
    id: "1",
    label: getLocaleText(
      "modals.ai_feedback_modal.thumbs_down_reason.lack_of_contextual_understanding"
    ),
    value: "lack of contextual understanding",
  },
  {
    id: "2",
    label: getLocaleText(
      "modals.ai_feedback_modal.thumbs_down_reason.repetitive_or_redundant"
    ),
    value: "repetitive or redundant",
  },
  {
    id: "3",
    label: getLocaleText(
      "modals.ai_feedback_modal.thumbs_down_reason.bias_or_offensive_content"
    ),
    value: "bias or offensive content",
  },
  {
    id: "4",
    label: getLocaleText(
      "modals.ai_feedback_modal.thumbs_down_reason.too_long_or_overly_wordy"
    ),
    value: "too long or overly wordy",
  },
  {
    id: "5",
    label: getLocaleText(
      "modals.ai_feedback_modal.thumbs_down_reason.poor_grammar_or_typos"
    ),
    value: "poor grammar or typos",
  },
];

const emit = defineEmits(["cancel", "close", "submitFeedback"]);

function cancel() {
  emit("cancel");
  emit("close");
}

function submitFeedback() {
  emit("submitFeedback", {
    thumbsUp: false,
    selectedReason: selectedReason.value,
  });

  emit("close");
}
</script>

<style lang="scss" scoped>
@import "shared/css/components/ai.scss";

:deep(.streem-modal2) {
  width: 320px !important;
  margin: 0 auto !important;
  border-radius: 16px !important;
}

:deep(.streem-modal2-buttons) {
  border-top: none !important;
  display: flex;
  padding: var(--s-spacing-lg);
  padding-top: 0;
  gap: var(--s-spacing-lg);
  justify-content: center;
}

:deep(.streem-modal2-content) {
  border: 1px solid white;
  border-radius: 16px;

  @extend %ai-gradient;
}
</style>
